import { Theme, alpha, Components } from "@mui/material/styles";
import { gray, orange, green, red, brand } from "../themePrimitives";

/* eslint-disable import/prefer-default-export */
export const feedbackCustomizations: Components<Theme> = {
  MuiAlert: {
    styleOverrides: {
      root: ({ theme }) => ({
        borderRadius: 10,
      }),
      standardSuccess: ({ theme }) => ({
        backgroundColor: green[100],
        color: (theme.vars || theme).palette.text.primary,
        border: `1px solid ${alpha(green[300], 0.5)}`,
        "& .MuiAlert-icon": {
          color: green[500],
        },
        ...theme.applyStyles("dark", {
          backgroundColor: `${alpha(green[800], 0.5)}`,
          border: `1px solid ${alpha(green[700], 0.5)}`,
          "& .MuiAlert-icon": {
            color: green[300],
          },
        }),
      }),
      standardError: ({ theme }) => ({
        backgroundColor: red[100],
        color: (theme.vars || theme).palette.text.primary,
        border: `1px solid ${alpha(red[300], 0.5)}`,
        "& .MuiAlert-icon": {
          color: red[500],
        },
        ...theme.applyStyles("dark", {
          backgroundColor: `${alpha(red[800], 0.5)}`,
          border: `1px solid ${alpha(red[700], 0.5)}`,
          "& .MuiAlert-icon": {
            color: red[300],
          },
        }),
      }),
      standardWarning: ({ theme }) => ({
        backgroundColor: orange[100],
        color: (theme.vars || theme).palette.text.primary,
        border: `1px solid ${alpha(orange[300], 0.5)}`,
        "& .MuiAlert-icon": {
          color: orange[500],
        },
        ...theme.applyStyles("dark", {
          backgroundColor: `${alpha(orange[900], 0.5)}`,
          border: `1px solid ${alpha(orange[800], 0.5)}`,
          "& .MuiAlert-icon": {
            color: orange[300],
          },
        }),
      }),
      standardInfo: ({ theme }) => ({
        backgroundColor: brand[100],
        color: (theme.vars || theme).palette.text.primary,
        border: `1px solid ${alpha(brand[300], 0.5)}`,
        "& .MuiAlert-icon": {
          color: brand[500],
        },
        ...theme.applyStyles("dark", {
          backgroundColor: `${alpha(brand[900], 0.5)}`,
          border: `1px solid ${alpha(brand[800], 0.5)}`,
          "& .MuiAlert-icon": {
            color: brand[300],
          },
        }),
      }),
    },
  },
  MuiDialog: {
    styleOverrides: {
      root: ({ theme }) => ({
        "& .MuiDialog-paper": {
          borderRadius: "10px",
          border: "1px solid",
          borderColor: (theme.vars || theme).palette.divider,
        },
      }),
    },
  },
  MuiLinearProgress: {
    styleOverrides: {
      root: ({ theme }) => ({
        height: 8,
        borderRadius: 8,
        backgroundColor: gray[200],
        ...theme.applyStyles("dark", {
          backgroundColor: gray[800],
        }),
      }),
    },
  },
};
